import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: React.ReactNode;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border-b border-gold/20 transition-colors duration-300 ${isOpen ? 'bg-gold/[0.04]' : ''}`} data-id="element-28">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between py-3.5 md:py-4 px-3 text-left gap-3" data-id="element-29">
        <span className={`text-sm md:text-[15px] leading-snug pr-2 transition-colors duration-300 ${isOpen ? 'text-gold font-bold' : 'text-navy font-semibold'}`} data-id="element-30">
          {question}
        </span>
        <ChevronDownIcon size={16} className={`flex-shrink-0 transition-all duration-300 ${isOpen ? 'rotate-180 text-gold' : 'text-gold/50'}`} data-id="element-31" />
      </button>
      <div className={`overflow-hidden transition-all duration-500 ease-out ${isOpen ? 'max-h-96 opacity-100 pb-3.5 px-3' : 'max-h-0 opacity-0'}`} data-id="element-32">
        <div className="text-charcoal/80 text-sm md:text-[15px] leading-relaxed space-y-2 pl-0.5" data-id="element-33">
          {answer}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  return <section className="py-4 md:py-10 px-4 md:px-6" data-id="element-34">
      <div className="max-w-[600px] mx-auto" data-id="element-35">
        <FadeIn data-id="element-36">
          <h2 className="font-serif text-xl md:text-2xl text-navy mb-3 md:mb-6 text-center" data-id="element-37">
            Frequently Asked Questions
          </h2>
        </FadeIn>

        <FadeIn delay={100} data-id="element-38">
          <div className="border-t border-gold/20 rounded-xl overflow-hidden" data-id="element-39">
            <FAQItem question="Is this just another budgeting guide?" answer={<>
                  <p data-id="element-41">No. Traditional budgeting focuses on tracking numbers.</p>
                  <p data-id="element-42">
                    This guide focuses on the psychology behind why spending
                    happens in the first place.
                  </p>
                  <p data-id="element-43">
                    Once emotional triggers become clear, impulse purchases
                    become much easier to control.
                  </p>
                </>} data-id="element-40" />
            <FAQItem question="What if I already know I overspend?" answer={<>
                  <p data-id="element-45">
                    Knowing you overspend isn't the same as understanding why
                    the urge appears.
                  </p>
                  <p data-id="element-46">
                    This guide reveals the emotional triggers and subconscious
                    patterns driving the behavior.
                  </p>
                </>} data-id="element-44" />
            <FAQItem question="Will this help me stop impulse purchases?" answer={<>
                  <p data-id="element-48">The goal isn't to eliminate spending completely.</p>
                  <p data-id="element-49">
                    The goal is to break the automatic emotional loop that leads
                    to purchases you later regret.
                  </p>
                </>} data-id="element-47" />
            <FAQItem question="Do I need financial expertise?" answer={<>
                  <p data-id="element-51">
                    Not at all. This guide was written for people who feel
                    capable in most areas of life but chaotic with money.
                  </p>
                  <p data-id="element-52">There are no spreadsheets or complicated math.</p>
                </>} data-id="element-50" />
            <FAQItem question="What if my spending is emotional?" answer={<>
                  <p data-id="element-54">
                    That's exactly what this guide addresses. Most impulse
                    spending is connected to stress, boredom, reward, and
                    identity expression.
                  </p>
                  <p data-id="element-55">
                    Once those triggers become visible, they lose much of their
                    power.
                  </p>
                </>} data-id="element-53" />
            <FAQItem question="How quickly can this help?" answer={<>
                  <p data-id="element-57">Many readers experience their first shift immediately.</p>
                  <p data-id="element-58">
                    Because once you see the psychological pattern clearly, your
                    brain begins responding differently.
                  </p>
                </>} data-id="element-56" />
          </div>
        </FadeIn>
      </div>
    </section>;
}